function Ethiopia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1144)">
  <path d="M0 16C0 17.9572 0.352062 19.832 0.99525 21.5653L16 22.9565L31.0047 21.5653C31.648 19.832 32 17.9571 32 16C32 14.0696 31.6581 12.2192 31.0316 10.5059L16 9.04346L0.968375 10.506C0.341938 12.2192 0 14.0696 0 16H0Z" fill="#FFDA44"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7442 27.6582 31.0049 21.5654H0.995239C3.25593 27.6582 9.12061 32.0002 16 32.0002Z" fill="#D80027"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0V0Z" fill="#6DA544"/>
  <path d="M16 23.652C20.2262 23.652 23.6522 20.226 23.6522 15.9998C23.6522 11.7737 20.2262 8.34766 16 8.34766C11.7738 8.34766 8.34778 11.7737 8.34778 15.9998C8.34778 20.226 11.7738 23.652 16 23.652Z" fill="#0052B4"/>
  <path d="M15.9984 10.0742L17.3798 14.3256H21.8571L18.2334 16.9532L19.6257 21.2172L15.9984 18.5771L12.3766 21.2123L13.7633 16.9532L10.1429 14.3256H14.617L15.9984 10.0742Z" fill="#FFDA44"/>
  <path d="M21.5078 17.0578L17.1256 15.6338L19.8339 11.9063L18.7084 11.0884L15.9999 14.8161L13.2917 11.0884L12.1661 11.9062L14.8744 15.634L10.4923 17.0577L10.9222 18.381L15.3044 16.9572V21.5648H16.6957V16.9571L21.0777 18.381L21.5078 17.0578Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Ethiopia;
